import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Reveal } from '../Reveal';
import { PRICING, PRICING_OPTIONS } from '../../data/content';
export function FinalClose({
  onCta
}: {
  onCta: () => void;
}) {
  const product = PRICING_OPTIONS[0];
  return <section className="w-full bg-cocoa px-5 py-16 text-cream sm:py-24" data-id="element-75" data-mp="2j6phhyt20l1u">
      <div className="mx-auto max-w-2xl text-center" data-id="element-76" data-mp="2o5ivdsc96e2j">
        <Reveal data-id="element-77" data-mp="2o50rqan9gxkl">
          <h2 className="font-display text-[32px] leading-tight sm:text-5xl" data-id="element-78" data-mp="2o7my46yf1718">
            Tu próxima creación no tiene que empezar con horas de búsqueda
          </h2>
          <p className="mx-auto mt-5 max-w-md font-display text-xl italic leading-snug text-cream/85 sm:text-2xl" data-id="element-79" data-mp="2x79ycpfes6sp">
            Puede empezar con una guía clara. Un modelo. Una aguja. Y el primer punto.
          </p>
        </Reveal>

        <Reveal delay={80} className="mt-10 border-t border-cream/15 pt-8" data-id="element-80" data-mp="12uagepnk30i9">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-gold" data-id="element-81" data-mp="17rsqijdb7lru">Megapack Bolsos Crochet Pro</p>
          <p className="mt-2 font-display text-3xl" data-id="element-82" data-mp="1tlatul1lwzu0">Aprendé. Creá. Emprendé.</p>

          {product && <p className="mt-6 font-display text-5xl leading-none sm:text-6xl" data-id="element-83" data-mp="1or6na2w96ttg">
              {product.price} <span className="font-sans text-sm font-bold text-cream/70" data-id="element-84" data-mp="1kr4i3jrb7i9f">{PRICING.currency}</span>
            </p>}
          <p className="mt-2 text-sm font-semibold text-cream/75" data-id="element-85" data-mp="1fpp0y2s95vwb">6 tomos + 5 bonos</p>

          <CtaButton className="mt-7 w-full max-w-sm" onClick={onCta} data-id="element-86" data-mp="2ch99419kr3jm">
            Quiero mi Megapack <ArrowRightIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-87" data-mp="28h8mhtcbnm1h" />
          </CtaButton>
          <p className="mt-3 text-xs font-semibold text-cream/70" data-id="element-88" data-mp="23fjb2cl6t6cv">
            Acceso inmediato · 100% digital · Garantía de 7 días
          </p>
        </Reveal>
      </div>
    </section>;
}